module.exports = __webpack_public_path__ + "static/media/9DESA1.307ff707.jpg";